var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-flex-cfsc"},[_c('div',{staticClass:"a-flex-1 a-w-100",attrs:{"id":"myChartCharge"}})])
}]

export { render, staticRenderFns }